/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import { clamp as t } from "../../core/mathUtils.js";
import { px2pt as r, pt2px as n } from "../../core/screenUtils.js";
import { l as o } from "../../chunks/vec4.js";
import { c as e } from "../../chunks/vec4f64.js";
const a = 2.4;
function i(t) {
  return r(t * a);
}
function c(t) {
  return n(t) / a;
}
function f(r, n, e, a) {
  let {
      color: i,
      ratio: c
    } = n,
    {
      color: f,
      ratio: u
    } = e;
  if (u === c) {
    const t = 1e-6;
    1 === u ? c -= t : u += t;
  }
  const s = t((a - c) / (u - c), 0, 1);
  o(r, i.toArray(), f.toArray(), s);
}
function u(t) {
  const r = 512,
    n = new Uint8ClampedArray(4 * r);
  if (t = t.filter(({
    ratio: t
  }) => t >= 0 && t <= 1).sort((t, r) => t.ratio - r.ratio).map(({
    color: t,
    ratio: r
  }) => ({
    color: t,
    ratio: Math.max(r, .001)
  })), t.length < 1) return n;
  let o = t[0],
    a = t[0],
    i = 1;
  const c = e();
  for (let e = 0; e < r; e++) {
    const u = (e + .5) / r;
    for (; u > a.ratio && i < t.length;) o = a, a = t[i++];
    f(c, o, a, u), n.set(c, 4 * e);
  }
  return n;
}
function s(t, r, o, e) {
  const {
      radius: a,
      fieldOffset: i,
      field: c
    } = r,
    f = Math.round(n(a)),
    u = new Float64Array(o * e);
  let s,
    l = Number.NEGATIVE_INFINITY;
  const h = d(c, i),
    y = new Set();
  for (const n of t) {
    const t = n.getCursor();
    for (; t.next();) {
      const r = t.getObjectId();
      if (y.has(r)) continue;
      y.add(r);
      const n = t.readLegacyPointGeometry(),
        a = 128;
      if (n.x < -a || n.x >= o + a || n.y < -a || n.y > e + a) continue;
      const i = +h(t),
        c = Math.max(0, Math.round(n.x) - f),
        d = Math.max(0, Math.round(n.y) - f),
        g = Math.min(e, Math.round(n.y) + f),
        A = Math.min(o, Math.round(n.x) + f);
      for (let t = d; t < g; t++) for (let r = c; r < A; r++) {
        const e = t * o + r,
          a = m(n.x - r, n.y - t, f);
        s = u[e] += a * i, s > l && (l = s);
      }
    }
  }
  return {
    matrix: u.buffer,
    max: l
  };
}
function l(t, r, n, o, e, a) {
  t.canvas.width = t.canvas.height = r, t.clearRect(0, 0, r, r);
  const i = t.getImageData(0, 0, r, r);
  n && o && i.data.set(new Uint8ClampedArray(h(r, n, o, e, a))), t.putImageData(i, 0, 0);
}
function h(r, n, o, e, a) {
  const i = new Uint32Array(r * r),
    c = "buffer" in n ? n : new Float64Array(n),
    f = "buffer" in o ? new Uint32Array(o.buffer) : new Uint32Array(new Uint8Array(o).buffer),
    u = f.length / (a - e);
  for (let s = 0; s < c.length; s++) {
    const r = c[s],
      n = Math.floor((r - e) * u);
    i[s] = f[t(n, 0, f.length - 1)];
  }
  return i.buffer;
}
function m(t, r, n) {
  const o = Math.sqrt(t ** 2 + r ** 2) / n;
  return o > 1 ? 0 : 3 / (Math.PI * n ** 2) * (1 - o ** 2) ** 2;
}
function y(t, r) {
  return "function" == typeof t ? t : t ? "string" == typeof r ? r => -1 * +r[t] : n => +n[t] + r : () => 1;
}
function d(t, r) {
  return null != t ? "string" == typeof r ? r => -1 * +r.readAttribute(t) : n => +n.readAttribute(t) + r : t => 1;
}
export { s as calculateHeatmapIntensityInfoReaders, h as createHeatmapImageData, y as createValueFunction, d as createValueFunctionCursor, l as drawHeatmap, m as evaluateDensityKernel, i as gaussianBlurRadiusPxToKernelDensityRadiusPt, u as generateGradient, c as kernelDensityRadiusPtToGaussianBlurRadiusPx, a as magicKernelDensityRadiusInflationFactor };